import React from "react"
import { PageHeader } from "antd"
import { useHistory, useLocation } from "react-router-dom"

interface PageCustomHeader {
    title: React.ReactNode
    subTitle?: string
    className?: string
    actionButtons?: React.ReactNode
}

interface LocationState {
    fromExpenseSwitching?: boolean
}

const PageCustomHeader: React.FC<PageCustomHeader> = ({ className, title, subTitle, actionButtons }) => {
    const history = useHistory()
    const location = useLocation<LocationState>()

    const goBack = () => {
        location.state?.fromExpenseSwitching ? history.push("/expenses") : history.goBack()
    }

    return <PageHeader className={className} onBack={() => goBack()} title={title} subTitle={subTitle} extra={actionButtons}></PageHeader>
}

export default PageCustomHeader